import { useSelectOptions } from 'hooks/use-options'
import { Form } from 'react-bootstrap'

export function Select({
    options: opts,
    optionLabel = 'label',
    optionValue = 'value',
    optionTemplate,
    placeholder,
    onChange,
    ...props
}) {
    const { options, mapOptions } = useSelectOptions({
        options: opts,
        optionLabel,
        optionValue,
        optionTemplate,
    })

    return (
        <Form.Select
            {...props}
            onChange={onChange ? (e) => onChange(e, mapOptions[e.target.value]) : undefined}
        >
            {placeholder && <option value=''>{placeholder}</option>}
            {options.map((opt) => (
                <option key={opt.key} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </Form.Select>
    )
}
